module.exports = __webpack_public_path__ + "static/Internet_of_Things_Solutions-4c657bd456457f634a55d6524d00c060.png";